module.exports = __webpack_public_path__ + "static/media/oz-ui.68b66fdf.png";